module.exports = __webpack_public_path__ + "img/rub.6f941022.svg";